export default __webpack_public_path__ + "static/media/2003.8b4ac463.png";